import { FunctionComponent } from 'react';
import { PricingPageShopProduct_magento2_products_items_Magento2_ConfigurableProduct_variants as MagentoProductVariant } from '../../hook/__generated__/PricingPageShopProduct';
import AuthenticatedUserUpgradeMessage from './AuthenticatedUserUpgradeMessage';
import BaseProductMessage from './BaseProductMessage';

enum ATTRIBUTE_CODES {
  LICENSE_CODE = 'license_code',
}

const findAttribute = (attributes, key, value) =>
  attributes?.find((attribute) => attribute?.[key] === value);

const ProductUpgradeMessage: FunctionComponent<{
  isAuthenticated?: boolean;
  selectedVariant: MagentoProductVariant | null;
  variants: Array<MagentoProductVariant | null> | null;
  selectVariant: (value: MagentoProductVariant) => void;
}> = ({ isAuthenticated, selectedVariant, variants, selectVariant }) => {
  const licenseCodeVariantsCount = variants?.filter((variant) =>
    findAttribute(variant?.attributes, 'code', ATTRIBUTE_CODES.LICENSE_CODE)
  ).length;

  if (!licenseCodeVariantsCount || licenseCodeVariantsCount < 2) {
    return null;
  }

  if (!isAuthenticated) {
    return <BaseProductMessage sku={selectedVariant?.product?.sku} />;
  }

  return (
    <AuthenticatedUserUpgradeMessage
      selectedVariant={selectedVariant}
      selectVariant={selectVariant}
      variants={variants}
    />
  );
};

export default ProductUpgradeMessage;
